import Modaal from "modaal";
/**
 * Adgallery
 * @constructor
 */
class Adgallery {
  constructor() {

  }
  /**
   * サンプル
   */
  init() {
    $(".video-alphaCharge01").modaal({type:'video'});
    $(".video-alphaCharge02").modaal({type:'video'});
    $(".video01").modaal({type:'video'});
    $(".video02").modaal({type:'video'});
    $(".video03").modaal({type:'video'});
    $(".video04").modaal({type:'video'});
    $(".video05").modaal({type:'video'});
    $(".video06").modaal({type:'video'});
    $(".video07").modaal({type:'video'});
    $(".video08").modaal({type:'video'});
    $(".video09").modaal({type:'video'});
    $(".video10").modaal({type:'video'});
    $(".video11").modaal({type:'video'});
    $(".video12").modaal({type:'video'});
  }
};

export default Adgallery;
